module.exports = __webpack_public_path__ + "img/twitter.fcbaa0de.png";